import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SessionService } from '../../services/session.service';

/**
 * Section navigation (replaces the page title on admin/portal pages).
 * Admins see the full admin tabs; non-admin (file-portal) users see only
 * their Files and Account Details.
 */
@Component({
    selector: 'app-admin-nav',
    imports: [RouterLink, RouterLinkActive],
    templateUrl: './admin-nav.component.html',
    styleUrl: './admin-nav.component.scss',
})
export class AdminNavComponent {
    private session = inject(SessionService);

    get isAdmin(): boolean {
        return this.session.isAdmin();
    }

    get isLocal(): boolean {
        return this.session.isLocal();
    }
}
